<template>
  <div class="sc-map-legend">
    <div class="sc-map-legend__header">
      {{ $t("title") }}
    </div>
    <div class="sc-map-legend__content">
      <ul class="sc-map-legend__list">
        <li class="sc-map-legend__item" v-for="item in items" :key="item.color">
          <div class="sc-map-legend__item-key">
            <div :class="`sc-map-legend__item-symbol ${item.color}`" />
          </div>
          <div class="sc-map-legend__item-value">
            {{ item.label }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const colors = ["blue", "green", "yellow", "red"];

export default {
  computed: {
    items() {
      const { matrix } = this.$store.state.situationCenter;
      const { min, max } = matrix;
      const step = (max - min) / 4;

      const toFixed = value => value.toFixed(2);

      const items = [1, 2, 3, 4].map(i => {
        let label;

        if (i === 1) label = `${toFixed(min)} - ${toFixed(min + step)}`;
        else if (i === 4)
          label = `${toFixed(min + step * 3)} - ${toFixed(max)}`;
        else
          label = `${toFixed(min + step * (i - 1))} - ${toFixed(
            min + step * i
          )}`;

        return {
          color: colors[i - 1],
          label
        };
      });

      return items;
    }
  }
};
</script>

<style lang="scss">
.sc-map-legend {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: var(--border-radius);
  border: 1px solid transparent;
  width: 200px;
  z-index: 1000;
  font-size: 11px;
  color: var(--white_white);
  user-select: none;

  background-color: var(--bg_panel_primary) !important;
  border-color: var(--dividers_low_contrast) !important;

  &__header {
    padding: 5px 10px;
    font-weight: bold;
    border-radius: var(--border-radius);
    color: var(--text_primary) !important;
    background-color: var(--bg_surface) !important;
  }

  &__content {
    padding: 8px;
  }

  &__item {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 5px;
    }

    &-key {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-value {
      margin-left: 10px;
      color: var(--text_secondary) !important;
    }

    &-symbol {
      width: 100%;
      border-radius: 4px;

      &.blue {
        height: 2px;
        background: rgba(46, 147, 254, 1);
      }
      &.green {
        height: 4px;
        background: rgba(85, 183, 126, 1);
      }
      &.yellow {
        height: 6px;
        background: rgba(248, 195, 72, 1);
      }
      &.red {
        height: 8px;
        background: rgba(214, 56, 56, 1);
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "title": "Матрицы корреспонденций"
  },
  "en": {
    "title": "Correspondence matrices"
  }
}
</i18n>
